export const ASYNC_FETCH = 'ILD_Confirmation/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_ILDCONFIRMATION = 'ILD_Confirmation/ASYNC_FETCH_SUCCESS_ILDCONFIRMATION';
export const ASYNC_FETCH_FAILURE = 'ILD_Confirmation/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ILD_Confirmation/ASYNC_FETCH_INVALIDATE';
export const SET_ISCONFIRM_LOAD = 'ILD_Confirmation/SET_ISCONFIRM_LOAD';
/**
 * action types
 * @type {string}
 */
